module.exports = __webpack_public_path__ + "static/media/aces_e_off.3cca91c7.svg";